import { format, isBefore } from 'date-fns';
import { generateDate } from '../../date-utils';
import IDate from '../../types/date';
import { DISPLAY_DATE } from '../../constants';

type ValidationResult = { pass: boolean; message: string };

// Simple util, primarily used to check e.g. licence dates, residency dates etc. against DOBs
/**
 * Formats two date values and validates that the first date is before the second date.
 *
 * @param date1 - The first date value to compare.
 * @param date2 - The second date value to compare against.
 * @returns ValidationResult - { pass: boolean; message: string } - a message will be populated in the event of a validation fail
 */
export const validateDateOrder = (date1: IDate, date2: IDate): ValidationResult => {
	const pass = { pass: true, message: '' };
	if (!date1 || !date2) return pass;
	const formattedDate1 = generateDate(date1);
	const formattedDate2 = generateDate(date2);

	return isBefore(formattedDate1, formattedDate2)
		? { pass: false, message: `Please select a date after ${format(formattedDate2, DISPLAY_DATE)}` }
		: pass;
};
